import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { loadUser, useCredentialsStore } from '../../Store/userStore.ts'
export const AuthLayer: React.FC<React.PropsWithChildren> = ({ children }) => {
    const { refreshToken, loading } = useCredentialsStore()
    useEffect(() => {
        loadUser()
    }, [])

    const navigate = useNavigate()

    useEffect(() => {
        if (!refreshToken && !loading) {
            navigate('/login')
        }
    }, [refreshToken, loading])

    return children
}
